import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackCancelQuickOrderListUploadParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/quickOrder/trackCancelQuickOrderListUpload";

const useTrackCancelQuickOrderListUpload = (
    parameters: TrackCancelQuickOrderListUploadParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.cancelQuickOrderListUpload, parameters, options);
};

export default useTrackCancelQuickOrderListUpload;
